<div class="pt-3">
  <h2>{{'PROJECTS_MODULE.ProjectBuilder.summary' | translate}}</h2>
  <div class="pl-2 mt-3">
    <ng-container *ngFor="let activity of activities$ | async">
      <app-project-activity-summary-card [activity]="activity"></app-project-activity-summary-card>
    </ng-container>
  </div>
</div>
